import { SelectableOption } from '../FilterBar/select/selectable-option';
import { DeviceManagerFilter } from '../../state/device/device-manager-filter';
import { DeviceMessageFilter } from '../../state/device-readings/device-message-filter';

export const getGatewayFilterString = (filter?: DeviceManagerFilter | DeviceMessageFilter) => {
  return filter?.gateways?.map((gateway: SelectableOption) => gateway.value).join(',');
};
